<style lang="scss" scoped>
@import "core";

$my-accent-font:
  'Hiragino Kaku Gothic ProN',
  'ヒラギノ角ゴ ProN W3',
  Meiryo,
  メイリオ,
  Osaka,
  'MS PGothic',
  arial,
  helvetica,
  sans-serif;

$rank-colors: (
  a: #e7682d,
  b: #e5be2a,
  c: #2bb25f,
  d: #4379cb,
  e: #a955b3,
  m: #989698,
  n: #e26a68,
  asterisk: #2a3c5f,
);

$my-divier-color: $color-divider;

.my-judgements {
  &__row {

    @include mq(pc) {
      display: flex;
      align-items: stretch;
      justify-content: space-between;
    }

    &:not(:first-child) {
      margin-top: 20px;
    }

    &--loader {
      display: block!important;
      text-align: center;
      margin-bottom: 30px;

      &__state {
        font-size: 20px;
      }

      &__spinner {
        margin-top: 20px;
      }

      img {
        margin-top: 20px;
        max-width: 100%;

        @include mq(sp) {
          width: 241px;
        }
      }
    }
  }

  &__column {
    @include mq(pc) {
      width: 50%;

      & + & {
        margin-left: 10px;
      }
      &:nth-child(4) {
        width: 0!important;
      }
    }

    @include mq(sp) {
      &:not(:first-child) {
        margin-top: 20px;
      }
    }
  }
}

.my-judgement {
  display: block;
  border: solid 1px $my-divier-color;
  padding: 0;
  flex: 1 1 auto;
  background: #fff;

  &__name {
    display: block;
    font-size: 16px;
    font-weight: bold;
    line-height: 1;
    // color: $color-primary;
    // color: #000;
    color: #fff;
    text-align: center;
    margin-bottom: 12px;
    padding: 10px 20px;
  }

  @each $key, $color in $rank-colors {
    &--#{$key} &__name {
      background: $color;
    }
  }

  &__body {
    padding: 0px 10px 20px 10px;
  }

  &__head {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }

  &__rank {
    font-family: $my-accent-font;
    font-size: 64px;
    font-weight: bold;
    padding: 0;
    width: 100px;
    line-height: 90px;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @each $key, $color in $rank-colors {
    &--#{$key} &__rank {
      color: $color;
    }
  }

  &__info {
    flex: 1 1 auto;
    margin-left: 10px;
    margin-right: -5px;
    padding-top: 8px;
    display: block;

    @media all and (max-width:540px) {
      padding-left: 10px;
    }

    &--has-divider {
      border-top: solid 1px $my-divier-color;
      border-bottom: solid 1px $my-divier-color;
    }

    &--stack {
      margin-left: 0;
      & > dt {
        padding: 5px;
        padding-bottom: 0;
        display: block!important;
        font-size: 10px;
        @include mq(pc) {
          line-height: 1rem;
        }
        @include mq(sp) {
          line-height: 2rem;
        }
      }

      & > dd {
        // text-align: right;
        font-size: 13px;
        padding-left: 5px;
      }
    }

    &--rows {
      & > dl {
        display: block;

        & > dt {
          display: inline-block;
          min-width: 3em;

          &:after {
            content: "：";
          }
        }

        & > dd {
          display: inline-block;
        }
      }
    }
  }

  &__text-score {
    color: #000;
    font-size: 30px;
    font-family: $my-accent-font;
    font-weight: bold;

    &--small {
      font-size: 18px;
    }
  }

  &__score-base-guide {
    margin-top: 10px;

    & > dt {
      color: #000;
      font-weight: bold;

      &:after {
        content: "：";
      }
    }
  }

  &__standard {
    border-top: solid 1px $my-divier-color;
    margin-top: 8px;
    padding-top: 8px;

    & > dt {
      display: inline-block;
    }

    & > dd {
      display: inline-block;
      margin-left: .5em;
    }
  }

  &__pass-line {
    margin-top: 8px;

    & > dt {
      display: block;

      & > span {
        display: inline-block;
        font-size: 12px;
        line-height: 1.2;
        color: #fff;
        padding: 3px 7px 2px 7px;
        margin-bottom: 8px;
      }
    }

    & > dd {
      display: inline-block;
    }
  }

  @each $key, $color in $rank-colors {
    &--#{$key} &__pass-line > dt > span {
      background: $color;
    }
  }

  &__notes {
    margin-top: 8px;
    font-size: 12px;
  }

  &--docking &__info {
    margin-right: 0;
  }

  &--banner {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.my-pull-vertical-align {
  vertical-align: -1.5em;
}

.my-banner {
  @include mq(pc) {
    width: 296px;
  }
}

.my-api-error-notice {
  color: $color-strong;
  margin-top: 10px;
  margin-bottom: 60px;

  @include mq(sp) {
    margin-bottom: 40px;
  }
}

.my-section {
  &__head-group {
    @include mq(pc) {
      display: flex;
      align-items: center;
    }

    &__links {
      margin-bottom: 10px;

      @include mq(pc) {
        display: flex;

        & > * {
          margin-left: 30px;
        }
      }

      @include mq(sp) {
        & > * {
          margin-top: 10px;
        }
      }
    }
  }

  &--select-offer {


    &__select {
      width: 100%;
      font-size: 16px;
    }
  }

  &--checker {
    margin-top: 40px;

    &__links {
      margin-top: 20px;

      & > li {
        @include mq(pc) {
          display: inline-block;

          &:not(:first-child) {
            margin-left: 20px;
          }
        }

        @include mq(sp) {
          text-indent: -1.7em;
          padding-left: 1.7em;

          &:not(:first-child) {
            margin-top: 10px;
          }
        }
      }
    }
  }

  &--courses {
    margin-top: 30px;
  }
  &--notes {
    margin-top: 20px;
  }
}

.my-define-lists {
  margin-top: 20px;
}

.my-define-list {
  @include mq(pc) {
    display: flex;
    flex: 1 0 50%;
    align-items: flex-start;
    justify-content: stretch;
  }

  margin-top: 20px;

  & > dt {
    flex: 0 0 auto;
    background: $color-bg-base;
    width: 130px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    @include mq(sp) {
      width: 100%;
      margin-bottom: 15px;
    }
  }

  & > dd {
    flex: 1 1 auto;
    @include mq(pc) {
      margin-left: 15px;
    }
  }
}

.my-nowrap {
  display: inline-block;
  white-space: nowrap;
}

.my-word-wrap {
  display: inline-block;
  white-space: nowrap;

  &:before {
    content: "「";
  }

  &:after {
    content: "」";
  }
}

.my-pending-btn {
  min-width: 180px;
  margin-top: 10px;

  @include mq(sp) {
    width: 100%;
  }
}

.text-red {
  color: red;
}
.my-offer {
  background: #fff;
  border: solid 1px $color-divider;
  position: relative;
  z-index: 1;
  transform-style: preserve-3d;
  backface-visibility: hidden;
  display: list-item !important;
  &--moving {
  }

  & + &:not(.my-offer--moving) {
    border-top: 0;
  }

  &__header {
    display: flex;
    align-items: stretch;
    background-color: #d9f6f6;

    &-body {
      padding: 10px 10px 10px 20px;
      margin-right: auto;

      @include mq(sp) {
        padding-left: 10px;
      }
    }

    &-rank {
/*
      color: $color-primary;
*/
      font-size: 16px;
      font-weight: bold;
      padding-top: 5px;
      padding-bottom: 5px;
    }


    &-action {
      @include btn-base($display: flex);
      width: 44px;
      align-items: center;
      justify-content: center;
      border-left: solid 1px $color-divider;
      transition: background-color .25s;
      display: -ms-flexbox;

      &.is-disabled {
        cursor: default;
        pointer-events: none;
      }

      &:not(.is-disabled) {
        &:hover,
        &:focus {
          background: #fafafa;
        }

        &:active {
          background: #efefef;
        }
      }
    }
  }

  &__body {
    padding: 20px;
    border-top: solid 1px $color-divider;

    @include mq(sp) {
      padding-left: 10px;
      padding-right: 10px;
    }
    .br-show {
      @include mq(pc) {
        display: none;
      }
    }
  }

  &__university-block {
    @include mq(pc) {
      display: flex;
    }
  }

  &__university-label {
    padding-top: 1px;
    @include mq(pc) {
      margin-left: 10px;
    }
    @include mq(sp) {
      margin-bottom: 10px;
    }
  }

  &__university-name {
    font-size: 16px;
    color: #000;
    font-weight: bold;
    margin: 0 0 10px;
  }

  &__meta {

    &-list {
      border-bottom: solid 2px $color-primary;
      padding-bottom: 8px;
    }

    display: inline-block;

    &:not(:first-child) {
      margin-left: 1em;
    }
  }

  &__links {
    letter-spacing: 4em;
  }

  &__link {
    display: inline-block;
    vertical-align: middle;
    margin-top: 10px;
    letter-spacing: normal;
  }

  &__missing-notice {
    padding-top: 10px;
    font-weight: bold;
    color: $color-strong;
  }

  &__kaiso {
    font-weight: bold;
    color: $color-strong;
  }

  .my-judgements {
    &__row {

      @include mq(pc) {
        display: flex;
        align-items: stretch;
        justify-content: space-between;
      }

      &:not(:first-child) {
        margin-top: 20px;
        display: -webkit-box;
      }

      &--loader {
        display: block!important;
        text-align: center;
        margin-bottom: 30px;

        &__state {
          font-size: 20px;
        }

        &__spinner {
          margin-top: 20px;
        }

        img {
          margin-top: 20px;
          max-width: 100%;

          @include mq(sp) {
            width: 241px;
          }
        }
      }
    }

    &__column {
        width: 25%;
      @include mq(pc) {

        & + & {
          margin-left: 10px;
        }
      }

      @include mq(sp) {
        &:not(:first-child) {
          margin-top: 0px;
        }
      }
    }
  }

  .my-judgement {
    display: block;
    border: solid 1px $my-divier-color;
    padding: 0;
    flex: 1 1 auto;
    background: #fff;
    // width: 25%;

    &:before,
    &:after {
      content: ""!important;
    }

    &__name {
      display: block;
      font-size: 14px;
      font-weight: bold;
      line-height: 1;
      // color: $color-primary;
      // color: #000;
      color: #fff;
      text-align: center;
      margin-bottom: 0;
      padding: 10px 0px;

      @include mq(sp) {
        font-size: 12px;
        line-height: 1.2;
      }
      br {
        @include mq(pc) {
          display: none;
        }
      }
    }

    @each $key, $color in $rank-colors {
      &--#{$key} &__name {
        background: $color;
      }
    }

    &__body {
      padding: 0px 10px 10px;
      @media (max-width: 440px) {
        padding: 0 5px 5px;
      }
    }

    &__head {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;

      @include mq(sp) {
        display: block;

        &--flex {
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          padding-top: 8px;
        }
      }
    }

    &__rank {
      font-family: $my-accent-font;
      font-size: 40px;
      font-weight: bold;
      padding: 0;
      width: 50px;
      line-height: 60px;
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;

      @include mq(sp) {
        font-size: 40px;
        line-height: 50px;
      }
    }

    @each $key, $color in $rank-colors {
      &--#{$key} &__rank {
        color: $color;
      }
    }

    &__info {
      flex: 1 1 auto;
      margin-left: 10px;
      margin-right: -5px;
      padding-top: 8px;
      display: block;

      @include mq(sp) {
        padding: 0;
        margin-left: 0;
      }

      // &--has-divider {
      //   border-top: solid 1px $my-divier-color;
      //   border-bottom: solid 1px $my-divier-color;
      // }

      &--stack {
        margin-left: 0;
        & > dt {
          padding: 5px;
          padding-bottom: 0;
          display: block!important;
          font-size: 10px;
          @include mq(pc) {
            line-height: 1rem;
          }
          @include mq(sp) {
            line-height: 2rem;
          }
        }

        & > dd {
          // text-align: right;
          font-size: 13px;
          padding-left: 5px;
        }
      }

      &--rows {
        & > dl {
          display: block;

          & > dt {
            display: inline-block;
            min-width: 3em;

            &:after {
              content: "：";
            }
          }

          & > dd {
            display: inline-block;
          }
        }
      }
    }

    &__text-score {
      color: #000;
      font-size: 20px;
      font-family: $my-accent-font;
      font-weight: bold;
      @media all and (max-width:540px) {
        font-size: 18px;
      }

      &--small {
        font-size: 13px;
        @media all and (max-width:540px) {
          font-size: 13px;
        }
      }
    }

    // &__next-hantei {
    //   @media all and (max-width:540px) {
    //   margin-left: -20px;
    //   }
    // }

    &__score-base-guide {
      font-size: 11px;

      & > dt {
        color: #000;
        font-weight: bold;

        &:after {
          content: "：";
        }
      }
    }

    &__standard {
      border-top: solid 1px $my-divier-color;
      margin-top: 5px;
      padding-top: 5px;
      font-size: 11px;

      & > dt {
        display: inline-block;
      }

      & > dd {
        display: inline-block;
        margin-left: .5em;
      }
    }

    &__pass-line {
      margin-top: 8px;
      font-size: 11px;

      & > dt {
        display: block;

        & > span {
          display: inline-block;
          font-size: 11px;
          line-height: 1.2;
          color: #fff;
          padding: 3px 7px 2px 7px;
          margin-bottom: 8px;
        }
      }

      & > dd {
        display: inline-block;
      }
    }

    @each $key, $color in $rank-colors {
      &--#{$key} &__pass-line > dt > span {
        background: $color;
      }
    }

    &__notes {
      margin-top: 8px;
      font-size: 11px;
    }

    &--docking &__info {
      margin-right: 0;
    }

    &--banner {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 0!important;
      @include mq(pc) {
        width: 50%;
      }
      @include mq(sp) {
        display: none;
      }
    }
  }

  .my-section {
    &__head-group {
      @include mq(pc) {
        display: flex;
        align-items: center;
      }

      &__links {
        margin-bottom: 10px;

        @include mq(pc) {
          display: flex;

          & > * {
            margin-left: 30px;
          }
        }

        @include mq(sp) {
          & > * {
            margin-top: 10px;
          }
        }
      }
    }

    &--select-offer {


      &__select {
        width: 100%;
        font-size: 16px;
      }
    }

    &--checker {
      margin-top: 40px;

      &__links {
        margin-top: 20px;

        & > li {
          @include mq(pc) {
            display: inline-block;

            &:not(:first-child) {
              margin-left: 20px;
            }
          }

          @include mq(sp) {
            text-indent: -1.7em;
            padding-left: 1.7em;

            &:not(:first-child) {
              margin-top: 10px;
            }
          }
        }
      }
    }

    &--courses {
      margin: 0 20px 20px;
    }
    &--notes {
      margin: 0 20px 20px;
    }
  }
}
.my-saiyo-lists {
  margin: 0;
  display: none;
}
.my-biko-lists {
  margin: 0;
}
.sticky {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  z-index: 100;
  text-align: center;
  height: 70px;
  background: #eff3f5;
  display: flex;
  justify-content: center;
  align-items: center;

  .dn-btn {
    width: 160px;
    height: auto;
    line-height: 25px;
    margin: 0 10px;
  }
}
.my-empty-icon {
  margin-left: 5px;
}
.gaibu-link {
  text-decoration: underline;
}
.dn-tabs {
  &__content {
    border-top: solid 1px $color-divider;
  }
}
.my {
  &__btn-under  {
    @include mq(sp) {
      width: 100%;
    }

    @include mq(pc) {
      min-width: 360px;
    }

    @media all and (max-width: 400px) {
      font-size: 11px;
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>



<template>
  <div id="pg-app">
    <template v-if="$store.getters['config/isManabi']">
    <div class="dn-tabs">
      <div class="dn-tabs__bar" v-if="!$store.getters['config/isManabi']">
        <div class="dn-tabs__container">
          <a href="../index.html" class="dn-tabs__item">
            自己採点
          </a>
          <a href="./index.html" class="dn-tabs__item dn-tabs__item--active">
            判定
          </a>
        </div>
      </div>
      <div class="dn-tabs__items">
        <div class="dn-tabs__content dn-tabs__content--active" style="border-top:1px solid #adc4cc;">

          <dn-db-downloader
            class="mb20"
            ref="downloader"
            target="@offers"
            v-model="downloadStatus"
            @data-ready="onDbDataReady"
            @download="onDownload"
          />

          <!-- DBのデータダウンロード完了時 START-->
          <div v-if="hasDbData">

            <section id="pg-sec-select-offer" class="my-section my-section--select-offer">
<!--
            <div class="dn-tabs mt20">
              <div class="dn-tabs__bar">
                <div class="dn-tabs__container">
                  <a class="dn-tabs__item dn-center-tabs__item--active" href="./../../../center/jikosaiten/hantei/index.html">第１日程</a>
                  <a class="dn-tabs__item" href="./../../../center2/jikosaiten/hantei/index.html">第２日程</a>
                </div>
                <div class="dn-center-tabs__item--under"></div>

              </div>
            </div> -->
            <!-- 第２日程2/2リリースタイミングで下記を表示 -->
            <!-- <div class="mt10 mb10">
              <p>第２日程実施後に、第１日程と第２日程の情報を再集計し更新しています。</p>
            </div> -->
            <!--  -->
              <div class="my-section__head-group">
                <h2 class="dn-heading-2">志望校</h2>

                <ul class="my-section__head-group__links" v-if="schoolChoicesIsReady">
                  <li>
                    <dn-icon icon="anchor" />
                    <a href="../../bible/search/index.html" v-linkset="'B6'">志望校を変更する</a>
                  </li>

                  <li>
                    <dn-icon icon="anchor" />
                    <a href="../../bible/myuniv/index.html" v-linkset="'B7'">志望校一覧</a>
                  </li>
                </ul>
              </div>

              <template v-if="schoolChoicesIsReady">
                <!--
                <dn-select
                  class="my-section--select-offer__select"
                  v-model="selectedOfferIndex"
                  @input="onChangeSelectedOfferIndex"
                >
                  <option :value="offerIndex" v-for="offer, offerIndex in schoolChoices" :key="offerIndex">{{offer.label}}</option>
                </dn-select>
                -->

                <p class="mt15">
                  ※出願の際には、各大学の最新の入試情報を確認してください。
                </p>

                <p class="mt5">
                  ※「N」判定は必要な科目を受験していない、もしくは1次通過ライン未達です。最新の入試情報を必ず確認してください。
                </p>

                <p class="mt5">
                  ※志望校によって、判定に備考情報がありますので、<span class="text-red">必ず</span>ページ下部の備考情報をご確認ください。
                </p>
              </template>

              <dn-btn v-else class="my-pending-btn" accent href="../../bible/search/index.html">志望校の登録</dn-btn>
            </section>

            <section id="pg-sec-checker" class="my-section my-section--checker">
              <div class="my-section__head-group" v-if="!$store.getters['config/isManabi']">
                <h2 class="dn-heading-2">判定{{$store.getters['config/isManabi'] ? '' : 'チェッカー'}}</h2>

                <ul class="my-section__head-group__links" v-if="isReady">
                  <li>
                    <dn-icon icon="anchor" />
                    <a :href="aboutWindow.url" :target="aboutWindow.url" @click.prevent="showAboutWindow">判定の見方</a>
                  </li>
                </ul>
              </div>

              <p class="my-api-error-notice" v-if="hasApiError">入力した得点に誤りがある可能性がありますので、確認してください。</p>

              <div v-if="!firstChoiceIsReady && firstChoiceErrors.length" class="mb30">
                <p v-for="firstChoiceError in firstChoiceErrors" :key="firstChoiceError.key" class="mt5">
                  {{firstChoiceError.name}}の第1解答科目が正しく選択されていません。
                </p>
                <p class="mt15">
                  <dn-icon icon="anchor" />
                  <a href="../index.html">第1解答科目を選択する</a>
                </p>
              </div>
              <dn-btn v-if="!selfcheckIsReady" class="my-pending-btn mb20" accent href="../index.html">自己採点をしよう</dn-btn>
              <div class="my-section__head-group">
                <h2 class="dn-heading-2">判定</h2>
                <ul class="my-section__head-group__links" v-if="isFetched && schoolChoicesIsReady">
                  <li>
                    <span class="vam">判定の見方</span>
                    <a class="my-empty-icon dn-icon dn-icon--btn dn-icon-question" title="判定の見方" :href="aboutWindow.url" :target="aboutWindow.url" @click.prevent="showAboutWindow"></a>
                  </li>
                  <li>
                    <dn-icon icon="attention" style="width:24px;height:24px;" />
                    <span class="vam">判定について備考情報があります。必ず確認してください。</span>
                  </li>
                </ul>
              </div>
              <div class="my-judgements">

                <div class="my-judgements__row my-judgements__row--loader" v-if="isFetching">
                  <p class="my-judgements__row--loader__state">判定中</p>
                  <dn-loading-spinner class="my-judgements__row--loader__spinner" />

                  <img :src="`${$store.getters['path/resources']}/jikosaiten/img/checker-loading-${loadingImageIndex}.png`" alt="">
                </div>

                <div class="my-judgements__row my-judgements__row--loader" v-if="isFetchFailed && !hasApiError">
                  <img :src="`${$store.getters['path/resources']}/jikosaiten/img/checker-load-failed.png`" alt="">
                </div>
                <!--
                <p v-if="isMissing">
                  大学入学共通テストを利用しない募集単位のため、判定できません。志望校の登録を再度ご確認ください。<br>
                  （国公立大学以外で大学入学共通テストを利用する場合は募集単位名に「共テ」がついています）
                </p>
                -->
                <ul class="my-offers" v-if="isFetched && schoolChoicesIsReady">
                  <li
                    :id="`my-offer-${offer.id}`"
                    v-for="(offer, index) in viewSchoolChoices"
                    :key="offer.id"
                    class="my-offer"
                    ref="offers"
                  >
                    <div class="my-offer__header">
                      <div class="my-offer__header-body">
                        <span class="my-offer__header-rank">第{{index + 1}}志望</span>
                      </div>
                      <a title="1つ上へ移動" class="my-offer__header-action" :class="{'is-disabled': offer.isFirst}" href="javascript:void(0);" @click.stop="moveOffer($event, offer, 'up')">
                        <dn-icon :class="{'is-disabled': offer.isFirst}" icon="tri-up" />
                      </a>
                      <a title="1つ下へ移動" class="my-offer__header-action" :class="{'is-disabled': offer.isLast}" href="javascript:void(0);" @click.stop="moveOffer($event, offer, 'down')">
                        <dn-icon :class="{'is-disabled': offer.isLast}" icon="tri-down" />
                      </a>
                      <a title="削除" class="my-offer__header-action" href="javascript:void(0);" @click.stop="deleteOffer($event, offer)"><dn-icon icon="trash" /></a>
                    </div>
                    <div class="my-offer__body">
                      <div v-if="offer.missing">
                        <p class="my-offer__kaiso">募集単位に改組がありました。<wbr>選択し直してください。</p>
                      </div>
                      <div v-else>
                        <!-- <label style="float:right;display:flex;justify-content:center;align-items:center;">
                          <p style="padding-right: 5px; text-align: center;">パンフ・<br class="br-show">願書<br>取り寄せ</p>
                          <input type="checkbox" name="pamphChoices" :value="offer.id" v-model="pamphletChoices" style="float:right;transform:scale(1.4);">
                        </label> -->
                        <div class="my-offer__university-block">
                          <h3 class="my-offer__university-name" :class="offer.id ? `uaimpcount_manacom_${offer.id.substring(0,4)}` : ''">{{offer.university_name}}</h3>
                          <p class="my-offer__university-label">{{offer.sLabel}}</p>
                        </div>
                        <div class="my-offer__meta-list">
                          <p><dn-icon icon="link" class="mr5" /><a class="gaibu-link" v-linkset="'C18'" :href="offer.id ? `https://manabi.benesse.ne.jp/daigaku/school/${offer.id.substring(0,4)}/nyushi/index.html` : ''" target="_blank">{{ $store.getters['config/isManabi'] ? '' : 'マナビジョンで'}}入試情報を見る</a></p>
                        </div>
                        <div v-if="offer.isMissing">
                          <p class="my-offer__missing-notice">大学入学共通テストを利用しない募集単位のため、判定できません。志望校の登録を再度ご確認ください。<br>（国公立大学以外で大学入学共通テストを利用する場合は募集単位名に「共テ」がついています）</p>
                        </div>
                        <div class="my-judgements__row" v-else>
                          <dl class="my-judgement my-judgements__column my-judgement--docking" :class="`my-judgement--${getJudgementRankClassSuffix(offer.rankDK.rank)}`" v-if="offer.rankDK && offer.rankDK.rank">
                            <dt class="my-judgement__name">ドッキング<br>判定</dt>
                            <dd class="my-judgement__body">
                              <div class="my-judgement__head">
                                <div class="my-judgement__rank">
                                  <rank-text :value="offer.rankDK && offer.rankDK.rank" />
                                </div>
                                <div class="my-judgement__info my-judgement__info--rows">
                                  <!-- <dl v-if="offer.rankDK.hasScore">
                                    <dt style="white-space: nowrap; font-size: 11px;">偏差値</dt>
                                    <dd class="my-judgement__text-score">{{offer.rankDK.dev}}</dd>
                                  </dl> -->
                                  <dl class="my-judgement__info--stack my-judgement__info--has-divider" v-if="offer.rankDK.rankUp">
                                    <dt>{{offer.rankDK.rankUp.rank}}判定に必要な<br>2次偏差値</dt>
                                    <dd class="my-judgement__text-score">{{offer.rankDK.rankUp.dev}}</dd>
                                  </dl>
                                </div>
                              </div>
                              <dl class="my-judgement__score-base-guide">
                                <dt>判定の基となる成績</dt>
                                <dd>共通テスト自己採点結果</dd>
                                <dd>進研模試 3年10月の結果</dd>
                              </dl>
                              <!-- <dl class="my-judgement__standard" v-if="offer.rankDK.standards">
                                <dt>判定基準</dt><br>
                                <dd v-for="standard in offer.rankDK.standards" :key="standard.key">{{standard.key}}:{{standard.value}}</dd>
                              </dl> -->
                            </dd>
                          </dl>
                          <dl class="my-judgement my-judgements__column my-judgement--docking" :class="`my-judgement--${getJudgementRankClassSuffix(offer.rank1.rank)}`" v-if="offer.rank1 && offer.rank1.rank">
                            <dt class="my-judgement__name">共テ<br>傾斜判定</dt>
                            <dd class="my-judgement__body">
                              <div class="my-judgement__head my-judgement__head--height">
                                <div class="my-judgement__rank">
                                  <rank-text :value="offer.rank1.rank" />
                                </div>
                                <div class="my-judgement__info my-judgement__info--rows">
                                  <dl v-if="offer.rank1.hasScore">
                                    <dt style="white-space: nowrap; font-size: 11px;">得点</dt>
                                    <dd class="my-judgement__text-score">{{offer.rank1.dev}}</dd>
                                  </dl>
                                  <dl class="my-judgement__next-hantei" v-if="offer.rank1.rankUp && offer.rank1.rankUp.rank && offer.rank1.rankUp.rank !== ' '">
                                    <dt style="font-size: 10px;"><span class="my-nowrap">{{offer.rank1.rankUp.rank}}判定</span><span class="my-nowrap">から</span></dt>
                                    <dd>
                                      <p class="my-judgement__text-score my-judgement__text-score--small">{{offer.rank1.rankUp.score}}点<span class="my-nowrap" style="font-size: 10px;text-align:right;font-weight:100;">（大学配点）</span></p>
                                    </dd>
                                  </dl>
                                </div>
                              </div>
                              <dl class="my-judgement__score-base-guide">
                                <dt>判定の基となる成績</dt>
                                <dd>共通テスト自己採点結果</dd>
                              </dl>
                              <dl class="my-judgement__standard" v-if="offer.rank1.standards">
                                <dt>判定基準</dt><br>
                                <dd v-for="standard in offer.rank1.standards" :key="standard.key">{{standard.key}}:{{standard.value}}</dd>
                              </dl>
                              <dl class="my-judgement__pass-line" v-if="offer.rank1.niDankai">
                                <dt><span>1次通過ライン</span></dt>
                                <dd>得点:{{offer.rank1.niDankai.score}}</dd>
                                <dd>ライン:{{offer.rank1.niDankai.line}}</dd>
                                <dd>配点:{{offer.rank1.niDankai.maxScore}}</dd>
                                <dd>倍率:{{offer.rank1.niDankai.bairitsu}}</dd>
                              </dl>
                              <p class="my-judgement__notes" v-if="offer.rank1.rank.slice(0,1)==='*'">[*]共通テストを1段階のみに利用</p>
                            </dd>
                          </dl>
                          <dl class="my-judgement my-judgements__column my-judgement--docking" :class="`my-judgement--${getJudgementRankClassSuffix(offer.rank2.rank)}`" v-if="offer.rank2 && offer.rank2.rank">
                            <dt class="my-judgement__name">２次<br>判定</dt>
                            <dd class="my-judgement__body">
                              <div class="my-judgement__head my-judgement__head--height">
                                <div class="my-judgement__rank">
                                  <rank-text :value="offer.rank2.rank" />
                                </div>
                                <div class="my-judgement__info my-judgement__info--rows">
                                  <dl v-if="offer.rank2.hasScore">
                                    <dt style="white-space: nowrap; font-size: 11px;">偏差値</dt>
                                    <dd class="my-judgement__text-score">{{offer.rank2.dev}}</dd>
                                  </dl>
                                  <dl class="my-judgement__next-hantei" v-if="offer.rank2.rankUp && offer.rank2.rankUp.rank && offer.rank2.rankUp.rank !== ' '">
                                    <dt style="font-size: 10px;"><span class="my-nowrap">{{offer.rank2.rankUp.rank}}判定</span><span class="my-nowrap">まであと</span></dt>
                                    <dd>
                                      <p class="my-judgement__text-score my-judgement__text-score--small">{{offer.rank2.rankUp.score}}点<span class="my-nowrap" style="font-size: 10px;text-align:right;font-weight:100;">（出題配点）</span></p>
                                    </dd>
                                  </dl>
                                </div>
                              </div>
                              <dl class="my-judgement__score-base-guide">
                                <dt>判定の基となる成績</dt>
                                <dd>進研模試 3年10月の結果</dd>
                              </dl>
                              <dl class="my-judgement__standard" v-if="offer.rank2.standards">
                                <dt>判定基準</dt><br>
                                <dd v-for="standard in offer.rank2.standards" :key="standard.key">{{standard.key}}:{{standard.value}}</dd>
                              </dl>
                              <dl class="my-judgement__pass-line" v-if="offer.rank2.niDankai">
                                <dt><span>1次通過ライン</span></dt>
                                <dd>得点:{{offer.rank2.niDankai.score}}</dd>
                                <dd>ライン:{{offer.rank2.niDankai.line}}</dd>
                                <dd>配点:{{offer.rank2.niDankai.maxScore}}</dd>
                                <dd>倍率:{{offer.rank2.niDankai.bairitsu}}</dd>
                              </dl>
                            </dd>
                          </dl>
                          <div class="my-judgements__column my-judgement--banner" v-if="!offer.isMissing">
                            <dn-bc-banner
                              class="my-banner"
                              screen="302"
                              type="05"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <section id="pg-sec-courses" class="my-section my-section--courses" v-if="!offer.missing && !offer.isMissing">
                      <div href="javascript:void(0);" @click="secCoursesOpen(index)">
                        <h3 class="dn-heading-3">採用科目<span class="dn-icon dn-icon-arrow-down" style="float:right;"></span></h3>
                        </div>
                      <div class="my-saiyo-lists" :class="`sec-courses-${index}`">
                        <dl class="my-define-list" v-if="offer.rank1 && offer.rank1.rank">
                          <dt>1次試験</dt>
                          <dd>
                            <span class="my-word-wrap" v-for="name, index in offer.rank1.selSubj" :key="index">{{name}}</span>
                          </dd>
                        </dl>
                        <dl class="my-define-list" v-if="offer.rank2 && offer.rank2.rank">
                          <dt>2次試験</dt>
                          <dd>
                            <span class="my-word-wrap" v-for="name, index in offer.rank2.selSubj" :key="index">{{name}}</span>
                          </dd>
                        </dl>
                      </div>
                    </section>
                    <section id="pg-sec-courses" class="my-section my-section--notes" v-if="!offer.missing && !offer.isMissing">
                      <div @click="secNotesOpen(index)">
                        <h3 class="dn-heading-3">
                          備考情報
                          <dn-icon icon="attention" v-if="offer.biko"/>
                          <span class="dn-icon dn-icon-arrow-down" style="float:right;"></span>
                        </h3>
                      </div>
                      <div class="my-biko-lists" :class="`sec-notes-${index}`">
                        <dl class="my-define-list" v-if="offer.rank1 && offer.rank1.rank">
                          <dt>1次試験</dt>
                          <dd>{{checkBiko(offer.rank1.biko)}}</dd>
                        </dl>
                        <dl class="my-define-list" v-if="offer.rank2 && offer.rank2.rank">
                          <dt>2次試験</dt>
                          <dd>{{checkBiko(offer.rank2.biko)}}</dd>
                        </dl>
                      </div>
                    </section>
                  </li>
                </ul>
              </div>

              <ul class="my-section--checker__links" v-if="(selfcheckIsReady || mockIsReady) && firstChoiceIsReady">
                <li v-if="!$store.getters['config/isManabi']">
                  <dn-icon icon="anchor" />
                  <a href="../index.html">大学入学共通テスト自己採点を入力する</a>
                </li>
                <li v-if="!$store.getters['config/isManabi']">
                  <dn-icon icon="anchor" />
                  <a href="../../bible/mock/index.html">記述模試の結果を登録する</a>
                </li>
                <li v-if="$store.getters['config/isManabi']">
                  <dn-icon icon="anchor" />
                  <a href="../index.html">共通テストの自己採点を登録する</a>
                </li>
              </ul>
            </section>

          </div>
          <!-- DBのデータダウンロード完了時 END-->

        </div>
      </div>
    </div>
    <div v-if="isFetched && schoolChoicesIsReady && $store.getters['config/isManabi']" class="dn-tabs__items" style="text-align:center;">
      <dn-icon icon="tri-down--lg" />
      <div class="dn-tabs__content dn-tabs__content--active">
        <p class="mb10" style="font-size:16px;">他にも志望校を検討してみましょう</p>
        <dn-btn accent class="my__btn-under my__btn-to-checker" href="../../bible/search/index.html" v-linkset="'B7'" style="font-size:14px;">＜＜　STEP2 志望校の登録へ</dn-btn>
      </div>
    </div>
    </template>
    <template v-else>
    <div class="dn-tabs">
      <div class="dn-tabs__bar">
        <div class="dn-tabs__container">
          <a href="../index.html" class="dn-tabs__item"  v-linkset="'C1'">
            自己採点
          </a>
          <a href="./index.html" class="dn-tabs__item dn-tabs__item--active" v-linkset="'C36'">
            判定
          </a>
        </div>
      </div>
      <div class="dn-tabs__items">
        <div class="dn-tabs__content dn-tabs__content--active" style="border-top: 0;">

          <dn-db-downloader
            class="mb20"
            ref="downloader"
            target="@offers"
            v-model="downloadStatus"
            @data-ready="onDbDataReady"
          />

          <!-- DBのデータダウンロード完了時 START-->
          <div v-if="hasDbData">

            <section id="pg-sec-select-offer" class="my-section my-section--select-offer">
<!-- 
            <div class="dn-tabs mt20">
              <div class="dn-tabs__bar">
                <div class="dn-tabs__container">
                  <a class="dn-tabs__item dn-center-tabs__item--active" v-linkset="'D1'" href="./../../../center/jikosaiten/hantei/index.html">第１日程</a>
                  <a class="dn-tabs__item" v-linkset="'D2'" href="./../../../center2/jikosaiten/hantei/index.html">第２日程</a>
                </div>
                <div class="dn-center-tabs__item--under"></div>

              </div>
            </div> -->
            <!-- 第２日程2/2リリースタイミングで下記を表示 -->
            <!-- <div class="mt10 mb10">
              <p>第２日程実施後に、第１日程と第２日程の情報を再集計し更新しています。</p>
            </div> -->
            <!--  -->
              <div class="my-section__head-group">
                <h2 class="dn-heading-2">志望校</h2>

                <ul class="my-section__head-group__links" v-if="schoolChoicesIsReady">
                  <li>
                    <dn-icon icon="anchor" />
                    <a href="../../bible/search/index.html" v-linkset="'B6'">志望校を変更する</a>
                  </li>

                  <li>
                    <dn-icon icon="anchor" />
                    <a href="../../bible/myuniv/index.html" v-linkset="'B7'">志望大学一覧</a>
                  </li>
                </ul>
              </div>

              <template v-if="schoolChoicesIsReady">
                <dn-select
                  class="my-section--select-offer__select"
                  v-model="selectedOfferIndex"
                  @input="onChangeSelectedOfferIndex"
                >
                  <option :value="offerIndex" v-for="offer, offerIndex in schoolChoices" :key="offerIndex">{{offer.label}}</option>
                </dn-select>

                <p class="mt15">
                  ※出願の際には、各大学の<a
                    href="#pg-sec-courses"
                    v-scroll-to="{
                      el: '#pg-sec-courses',
                      offset: -20,
                    }"
                  >最新の入試情報</a>を確認してください。
                </p>

                <p class="mt5">※「N」判定は必要な科目を受験していない、もしくは1次通過ライン未達です。<a
                    href="#pg-sec-courses"
                    v-scroll-to="{
                      el: '#pg-sec-courses',
                      offset: -20,
                    }"
                  >最新の入試情報</a>を必ず確認してください。</p>
              </template>

              <dn-btn v-else class="my-pending-btn" accent href="../../bible/search/index.html">志望校を登録しよう</dn-btn>
            </section>

            <section id="pg-sec-checker" class="my-section my-section--checker">
              <div class="my-section__head-group">
                <h2 class="dn-heading-2">判定{{$store.getters['config/isManabi'] ? '' : 'チェッカー'}}</h2>

                <ul class="my-section__head-group__links" v-if="isReady">
                  <li>
                    <dn-icon icon="anchor" />
                    <a :href="aboutWindow.url" :target="aboutWindow.url" @click.prevent="showAboutWindow">判定の見方</a>
                  </li>
                </ul>
              </div>

              <p class="my-api-error-notice" v-if="hasApiError">入力した得点に誤りがある可能性がありますので、確認してください。</p>

              <div v-if="!firstChoiceIsReady && firstChoiceErrors.length" class="mb30">
                <p v-for="firstChoiceError in firstChoiceErrors" :key="firstChoiceError.key" class="mt5">
                  {{firstChoiceError.name}}の第1解答科目が正しく選択されていません。
                </p>
                <p class="mt15">
                  <dn-icon icon="anchor" />
                  <a href="../index.html">第1解答科目を選択する</a>
                </p>
              </div>

              <dn-btn v-if="!selfcheckIsReady" class="my-pending-btn mb20" accent href="../index.html">自己採点をしよう</dn-btn>

              <div class="my-judgements">

                <div class="my-judgements__row my-judgements__row--loader" v-if="isFetching">
                  <p class="my-judgements__row--loader__state">判定中</p>
                  <dn-loading-spinner class="my-judgements__row--loader__spinner" />

                  <img :src="`${$store.getters['path/resources']}/jikosaiten/img/checker-loading-${loadingImageIndex}.png`" alt="">
                </div>

                <div class="my-judgements__row my-judgements__row--loader" v-if="isFetchFailed && !hasApiError">
                  <img :src="`${$store.getters['path/resources']}/jikosaiten/img/checker-load-failed.png`" alt="">
                </div>

                <p v-if="isMissing">
                  大学入学共通テストを利用しない募集単位のため、判定できません。志望校の登録を再度ご確認ください。<br>
                  （国公立大学以外で大学入学共通テストを利用する場合は募集単位名に「共テ」がついています）
                </p>

                <div class="my-judgements__row">
                  <dl class="my-judgement my-judgements__column my-judgement--docking" :class="`my-judgement--${getJudgementRankClassSuffix(docking.rank)}`" v-if="isReady">
                    <dt class="my-judgement__name">ドッキング判定</dt>
                    <dd class="my-judgement__body">
                      <div class="my-judgement__head">
                        <div class="my-judgement__rank">
                          <rank-text :value="docking.rank" />
                        </div>
                        <dl class="my-judgement__info my-judgement__info--stack my-judgement__info--has-divider" v-if="docking.rankUp">
                          <dt>{{docking.rankUp.rank}}判定に必要な<br>2次偏差値</dt>
                          <dd class="my-judgement__text-score">{{docking.rankUp.dev}}</dd>
                        </dl>
                      </div>
                      <dl class="my-judgement__score-base-guide">
                        <dt>判定の基となる成績</dt>
                        <dd>大学入学共通テスト自己採点結果</dd>
                        <dd>第2回ベネッセ・駿台記述模試・10月の結果</dd>
                      </dl>
                    </dd>
                  </dl>

                  <div class="my-judgements__column my-judgement--banner">
                    <dn-bc-banner
                      class="my-banner"
                      screen="302"
                      type="05"
                    />
                  </div>
                </div>
                <div class="my-judgements__row" v-if="isReady">
                  <dl class="my-judgement my-judgements__column my-judgement--stepable" :class="`my-judgement--${getJudgementRankClassSuffix(deci1.rank)}`">
                    <dt class="my-judgement__name">共テ傾斜判定</dt>
                    <dd class="my-judgement__body">
                      <div class="my-judgement__head">
                        <div class="my-judgement__rank">
                          <rank-text :value="deci1.rank" />
                        </div>
                        <div class="my-judgement__info my-judgement__info--rows">
                          <dl v-if="deci1.hasScore">
                            <dt style="white-space: nowrap;">得点</dt>
                            <dd class="my-judgement__text-score">{{deci1.dev}}</dd>
                          </dl>
                          <dl v-if="deci1.rankUp">
                            <dt><span class="my-nowrap">{{deci1.rankUp.rank}}判定</span><span class="my-nowrap">から</span></dt>
                            <dd class="my-pull-vertical-align">
                              <p class="my-judgement__text-score my-judgement__text-score--small">{{deci1.rankUp.score}}点</p>
                              <p><span class="my-nowrap" style="font-size: 10px;">（大学配点）</span></p>
                            </dd>
                          </dl>
                        </div>
                      </div>
                      <dl class="my-judgement__score-base-guide">
                        <dt>判定の基となる成績</dt>
                        <dd>大学入学共通テスト自己採点結果</dd>
                      </dl>
                      <dl class="my-judgement__standard" v-if="deci1.standards">
                        <dt>判定基準</dt>
                        <dd v-for="standard in deci1.standards" :key="standard.key">{{standard.key}}:{{standard.value}}</dd>
                      </dl>
                      <dl class="my-judgement__pass-line" v-if="deci1.niDankai">
                        <dt><span>1次通過ライン</span></dt>
                        <dd>得点:{{deci1.niDankai.score}}</dd>
                        <dd>ライン:{{deci1.niDankai.line}}</dd>
                        <dd>配点:{{deci1.niDankai.maxScore}}</dd>
                        <dd>倍率:{{deci1.niDankai.bairitsu}}</dd>
                      </dl>
                      <p class="my-judgement__notes" v-if="deci1.rank==='*'">[*]大学入学共通テストを1段階のみに利用</p>
                    </dd>
                  </dl>

                  <dl class="my-judgement my-judgements__column my-judgement--stepable" :class="`my-judgement--${getJudgementRankClassSuffix(deci2.rank)}`">
                    <dt class="my-judgement__name">2次判定</dt>
                    <dd class="my-judgement__body">
                      <div class="my-judgement__head">
                        <div class="my-judgement__rank">
                          <rank-text :value="deci2.rank" />
                        </div>
                        <div class="my-judgement__info my-judgement__info--rows" v-if="deci2.isAToE">
                          <dl v-if="deci2.hasScore">
                            <dt style="white-space: nowrap;">偏差値</dt>
                            <dd class="my-judgement__text-score">{{deci2.dev}}</dd>
                          </dl>
                          <dl v-if="deci2.rankUp && deci2.rankUp.rank && deci2.rankUp.rank !== ' '">
                            <dt><span class="my-nowrap">{{deci2.rankUp.rank}}判定まで</span><span class="my-nowrap">あと</span></dt>
                            <dd class="my-pull-vertical-align">
                              <p class="my-judgement__text-score my-judgement__text-score--small">{{deci2.rankUp.score}}点</p>
                              <p><span class="my-nowrap" style="font-size: 10px;">（出題配点）</span></p>
                            </dd>
                          </dl>
                        </div>
                      </div>
                      <dl class="my-judgement__score-base-guide">
                        <dt>判定の基となる成績</dt>
                        <dd>第2回ベネッセ・駿台記述模試・10月の結果</dd>
                      </dl>
                      <dl class="my-judgement__standard" v-if="deci2.standards">
                        <dt>判定基準</dt>
                        <dd v-for="standard in deci2.standards" :key="standard.key">{{standard.key}}:{{standard.value}}</dd>
                      </dl>
                      <dl class="my-judgement__pass-line" v-if="deci2.niDankai">
                        <dt><span>1次通過ライン</span></dt>
                        <dd>得点:{{deci2.niDankai.score}}</dd>
                        <dd>ライン:{{deci2.niDankai.line}}</dd>
                        <dd>配点:{{deci2.niDankai.maxScore}}</dd>
                        <dd>倍率:{{deci2.niDankai.bairitsu}}</dd>
                      </dl>
                    </dd>
                  </dl>
                </div>
              </div>

              <ul class="my-section--checker__links">
                <li>
                  <dn-icon icon="anchor" />
                  <a href="../index.html">大学入学共通テスト自己採点を入力する</a>
                </li>
                <li>
                  <dn-icon icon="anchor" />
                  <a href="../../bible/mock/index.html">記述模試の結果を登録する</a>
                </li>
              </ul>
            </section>

            <section id="pg-sec-courses" class="my-section my-section--courses" v-if="isReady">
              <h3 class="dn-heading-3">採用科目</h3>

              <div class="my-define-lists">
                <dl class="my-define-list">
                  <dt>1次試験</dt>
                  <dd>
                    <span class="my-word-wrap" v-for="name, index in deci1.selSubj" :key="index">{{name}}</span>
                  </dd>
                </dl>
                <dl class="my-define-list">
                  <dt>2次試験</dt>
                  <dd>
                    <span class="my-word-wrap" v-for="name, index in deci2.selSubj" :key="index">{{name}}</span>
                  </dd>
                </dl>
              </div>
            </section>

            <section id="pg-sec-courses" class="my-section my-section--notes" v-if="isReady">
              <h3 class="dn-heading-3">備考情報</h3>

              <div class="my-define-lists">
                <dl class="my-define-list">
                  <dt>1次試験</dt>
                  <dd>{{deci1.biko}}</dd>
                </dl>
                <dl class="my-define-list">
                  <dt>2次試験</dt>
                  <dd>{{deci2.biko}}</dd>
                </dl>
              </div>
            </section>

          </div>
          <!-- DBのデータダウンロード完了時 END-->

        </div>
      </div>
    </div>

    <section id="pg-sec-courses" class="my-section my-section--notes mt40 pb20" v-if="currentUniversityId">
      <h2 class="dn-heading-2">入試日程・科目情報</h2>
      <p class="mt20">
        <span class="dn-icon dn-icon-anchor"></span>
        <a v-linkset="'C18'" :href="`https://manabi.benesse.ne.jp/daigaku/school/${currentUniversityId}/nyushi/index.html`" target="_blank">入試日程や入試科目をマナビジョンで確認する</a>
      </p>
    </section>
    </template>
  </div>
</template>



<script>
let _fetchRequestId = 0;
import JudgementInfo from 'models/judgementInfo';
import RankText from './components/RankText';
import PreferredUnivManager from 'models/PreferredUnivManager';



export default {
  name: 'dn-checker-app',

  components: {
    RankText,
  },

  data() {
    return {
      mockIsReady: false,
      selfcheckIsReady: false,
      firstChoiceIsReady: false,
      firstChoiceErrors: [],
      schoolChoices: [],
      viewSchoolChoices: [],
      downloadStatus: null,
      selectedOfferIndex: this.getIndexByQuery(),
      fetchState: 'pending',
      judgements: null,
      loadingImageIndex: 1,
      aboutWindow: {
        url   : './about.html',
        target: 'dn-checker-about',
      },
      isAnimating: false,
      missings: [],
      needFetch       : true,
      hits            : null,
      hashJumped      : false,
      pamphletChoices: [],
      cartWindow : null,
    }
  },



  computed: {
    // refs
    $downloader() { return this.$refs.downloader },
    searchValues() { return {id: this.schoolChoices.map(id => id)} },
    isReady() { return this.isFetched && this.hasJudgement && !this.judgement.isMissing },
    isMissing() { return this.isFetched && this.hasJudgement && this.judgement.isMissing },
    isFetching() { return this.fetchState === 'fetching' },
    isFetched() { return this.fetchState === 'fetched' },
    hasApiError() { return this.fetchState === 'apiError' },
    isFetchFailed() { return this.hasApiError || this.fetchState === 'failed' },
    infoIsReady() { return this.selfcheckIsReady && this.firstChoiceIsReady },
    schoolChoicesIsReady() { return !!this.schoolChoices.length },
    hasDbData() { return this.downloadStatus ? this.downloadStatus.hasData : false },
    canFetch() { return this.hasDbData && this.infoIsReady && this.schoolChoicesIsReady },
    hasJudgements() { return this.judgements !== null },
    selectedOfferId() {
      if (this.schoolChoicesIsReady) {
        const choice = this.schoolChoices[this.selectedOfferIndex];
        if (choice) return choice.id;
      }
      return null;
    },
    currentUniversityId() { return this.selectedOfferId ? this.selectedOfferId.slice(0, 4) : null },
    judgement() {
      if (this.judgements && this.selectedOfferId) {
        const judgement = this.judgements[this.selectedOfferId];
        return judgement || null;
      }
      return null;
    },
    hasJudgement() { return this.judgement !== null },
    isAllEnt() { return this.judgement && this.judgement.allentFlg === '1' },
    isCenterFlg() { return this.judgement && this.judgement.centerFlg === '0' },
    // isSGRank() { return !this.isCenterFlg && this.deciSG.rank !== "" },
    docking() {
      if (!this.judgement) return null;
      const context   = this.judgement.deciDK;
      const isAToE    = 'ABCDE'.includes(context.rank);
      const hasRankUp = context.rankUpRank && context.rankUpDev;

      if (this.$store.getters['config/isManabi']) {
        return {
          rank: context.rank,
          dev : context.dev,
          hasScore: isAToE,
          rankUp: (hasRankUp && 'BCDE'.includes(context.rank) && this.judgement.deciList[0].rank !== '*') ? {
            rank: context.rankUpRank,
            dev : (context.rankUpDev + '').split('.')[0] + '～',
          } : null,
          standards: this.getStandardsByContext(context),
        }
      } else {
      return {
        rank: context.rank,
        rankUp: (hasRankUp && 'BCDE'.includes(context.rank) && this.judgement.deciList[0].rank !== '*') ? {
          rank: context.rankUpRank,
          dev : (context.rankUpDev + '').split('.')[0] + '～',
        } : null,
      }
      }
    },
    deci1() {
      if (!this.judgement) return null;
      const context   = this.judgement.deciList[0];
      const isAToE    = 'ABCDE'.includes(context.rank);
      const hasRankUp = context.rankUpRank && context.rankUpScore;

      return {
        rank: context.rank,
        dev : context.dev,
        hasScore: isAToE,
        rankUp: hasRankUp && 'ABCDE*'.includes(context.rank) ? {
          rank : context.rankUpRank,
          score: context.rankUpScore,
        } : null,
        standards: this.getStandardsByContext(context),
        niDankai: context.niDankai ? (
          !!context.niDankai.bairitsu
          || !!context.niDankai.line
          || !!context.niDankai.maxScore
          || !!context.niDankai.score
          ? context.niDankai : null
        ) : null,
        selSubj: [
          ...context.japSelSubj,
          ...context.mathSelSubj,
          ...context.engSelSubj,
          ...context.sociSelSubj,
          ...context.scieSelSubj,
        ],
        biko: context.biko || null,
      }
    },
    deci2() {
      if (!this.judgement) return null;
      const context   = this.judgement.deciList[1];
      const isAToE    = 'ABCDE'.includes(context.rank);
      const hasRankUp = context.rankUpRank && context.rankUpScore;

      return {
        rank  : context.rank,
        isAToE: isAToE,
        hasScore: isAToE,
        dev   : isAToE ? context.dev : null,
        rankUp: hasRankUp && isAToE ? {
          rank : context.rankUpRank,
          score: context.rankUpScore,
        } : null,
        standards: this.getStandardsByContext(context),
        niDankai: context.niDankai,
        selSubj: [
          ...context.japSelSubj,
          ...context.mathSelSubj,
          ...context.engSelSubj,
          ...context.sociSelSubj,
          ...context.scieSelSubj,
        ],
        biko: context.biko || null,
      }
    },
  },



  methods: {
    secCoursesOpen(index) {
      $(".sec-courses-"+index.toString(10)).slideToggle();
    },
    secNotesOpen(index) {
      $(".sec-notes-"+index.toString(10)).slideToggle();
    },
    getJudgementRankClassSuffix(rank) {
      if (rank.slice(0,1) === '*') return 'asterisk';
      return rank.toLowerCase();
    },
    getStandardsByContext(context) {
      return 'ABCDE'.includes(context.rank) ? (() => {
        const keys = ['A', 'B', 'C'];
        if (!this.isAllEnt) keys.push('D');

        return keys.map(key => { return {key, value: context[`rank${key}Base`]} });
      })() : null;
    },

    onChangeSelectedOfferIndex(index) {
      this.setOfferQuery(index);
    },

    getIndexByQuery() {
      let index = parseInt(this.$route.query.offer, 10) - 1;
      return isNaN(index) ? 0 : (index < 0 ? 0 : index);
    },

    // こいつがコールされるまでは全てが始まらない
    onDbDataReady() {
      this.init();
    },

    /**
     * データのダウンロードが発生した後のコールバック
     */
    async onDownload() {
      await this.pushFetchQueue();
    },

    async init() {
      await Promise.all([
        this.info.init(),
        dn.segments.ready(),
      ]);

      await this.restoreStates();
      this.state = 'ready';
    },

    async restoreStates() {
      this.restoreInfoState();
      await this.restoreSchoolChoices();
      await this.fetch();
      if (this.$store.getters['config/isManabi']) {
        await this.restoreSchoolChoices();
      }
    },

    updateLoadingImageIndex() {
      this.loadingImageIndex =  Math.floor(Math.random() * 5) + 1;
    },

    async fetch() {
      if (!this.canFetch) return;

      this.updateLoadingImageIndex();
      this.fetchState = 'fetching';

      try {
        this.judgements = await this.info.fetch();
      } catch(e) {
        this.fetchState = e.name === 'dn-judgement-api-error' ? 'apiError' : 'failed';
        throw e;
      }

      this.fetchState = 'fetched';
      return this.judgements;
    },

    async restoreSchoolChoices() {
      const offerIds = dn.segments.schoolChoices.find();
      if (this.selectedOfferIndex >= offerIds.length) {
        this.selectedOfferIndex = 0;
        this.setOfferQuery(this.selectedOfferIndex);
      }

      await this.fetchSchoolChoices(offerIds);
    },

    fetchSchoolChoices(offerIds) {
      if (this.$store.getters["config/isManabi"]) {
      return new Promise((resolve, reject) => {
        const displayItemDetailKeys = [
          'faculty_name',
          'department_name',
          'schedule_name',
          'examination_method_name',
        ];

        const condition = {id: offerIds};
        dn.db.searchOffers(condition)
          .then(hits => {
            const schoolChoices = [];
            offerIds.forEach((id, index) => {
              const offer = hits.hits.find(hit => hit.id === id);
              if (!offer) {
                schoolChoices.push(Object.assign({
                  isFirst: index === 0,
                  isLast : index === offerIds.length - 1,
                  missing: true,
                  id: id,
                }));
              } else {
                const labels = [`【第${index + 1}志望】`, offer.university_name];
                const sLabels = [];
                displayItemDetailKeys.forEach(key => {
                  const val = offer[key];
                  if (val) {
                    labels.push(val);
                    sLabels.push(val);
                  }
                });
                schoolChoices.push(Object.assign({
                  label: labels.join('　'),
                  sLabel: sLabels.join('　'),
                  isFirst: index === 0,
                  isLast : index === offerIds.length - 1,
                }, offer));
              }
            });
            this.schoolChoices = schoolChoices;
            resolve();
          })
          .catch(reject);
        dn.db.searchOffers(condition)
          .then(hits => {
            const schoolChoices = [];
            offerIds.forEach((id, index) => {
              const offer = hits.hits.find(hit => hit.id === id);
              if (!offer) {
                // 改組のある学校
                schoolChoices.push(Object.assign({
                  isFirst: index === 0,
                  isLast : index === offerIds.length - 1,
                  missing: true,
                  id: id,
                }));
              } else {
                const labels = [`【第${index + 1}志望】`, offer.university_name];
                const sLabels = [];
                displayItemDetailKeys.forEach(key => {
                  const val = offer[key];
                  if (val) {
                    labels.push(val);
                    sLabels.push(val);
                  }
                });
                const choice = this.schoolChoices[index];
                const judgement = this.judgements[choice.id];
                const isMissing = judgement.isMissing;
                const contextDK   = judgement.deciDK;
                const isAToEDK    = 'ABCDE'.includes(contextDK.rank);
                const hasRankUpDK = contextDK.rankUpRank;
                const context1   = judgement.deciList[0];
                const isAToE1    = 'ABCDE'.includes(context1.rank);
                const hasRankUp1 = context1.rankUpRank && context1.rankUpScore;
                const context2   = judgement.deciList[1];
                const isAToE2    = 'ABCDE'.includes(context2.rank);
                const hasRankUp2 = context2.rankUpRank && context2.rankUpScore;
                // const contextSG   = judgement.deciList[2];
                // const isAToESG    = 'ABCDE'.includes(contextSG.rank);
                // const hasRankUpSG = contextSG.rankUpRank && contextSG.rankUpScore;
                if(contextDK.rank || context1.rank || context2.rank/** || contextSG.rank */){
                  schoolChoices.push(Object.assign({
                    rankDK: {
                      rank: contextDK.rank,
                      dev : contextDK.dev,
                      hasScore: isAToEDK,
                      rankUp: (hasRankUpDK && 'BCDE'.includes(contextDK.rank) && context1.rank !== '*') ? {
                        rank: contextDK.rankUpRank,
                        dev : (contextDK.rankUpDev + '').split('.')[0] + '.0',
                      } : null,
                      standards: this.getStandardsByContext(contextDK),
                    },
                    rank1: {
                      rank: context1.rank,
                      dev : context1.dev,
                      hasScore: isAToE1,
                      rankUp: hasRankUp1 && 'ABCDE*'.includes(context1.rank) ? {
                        rank : context1.rankUpRank,
                        score: context1.rankUpScore,
                      } : null,
                      standards: this.getStandardsByContext(context1),
                      niDankai: context1.niDankai ? (
                        !!context1.niDankai.bairitsu
                        || !!context1.niDankai.line
                        || !!context1.niDankai.maxScore
                        || !!context1.niDankai.score
                        ? context1.niDankai : null
                      ) : null,
                      selSubj: [
                        ...context1.japSelSubj,
                        ...context1.mathSelSubj,
                        ...context1.engSelSubj,
                        ...context1.sociSelSubj,
                        ...context1.scieSelSubj,
                      ],
                      biko: context1.biko || null,
                    },
                    rank2: {
                      rank  : context2.rank,
                      isAToE: isAToE2,
                      hasScore: isAToE2,
                      dev   : isAToE2 ? context2.dev : null,
                      rankUp: hasRankUp2 && isAToE2 ? {
                        rank : context2.rankUpRank,
                        score: context2.rankUpScore,
                      } : null,
                      standards: this.getStandardsByContext(context2),
                      niDankai: context2.niDankai,
                      selSubj: [
                        ...context2.japSelSubj,
                        ...context2.mathSelSubj,
                        ...context2.engSelSubj,
                        ...context2.sociSelSubj,
                        ...context2.scieSelSubj,
                      ],
                      biko: context2.biko || null,
                    },
                    biko: context1.biko || context2.biko/** || contextSG.biko*/ || null,
                    label: labels.join('　'),
                    sLabel: sLabels.join('　'),
                    isFirst: index === 0,
                    isLast : index === offerIds.length - 1,
                    centerFlg: judgement.centerFlg === "1",
                    isMissing: isMissing,
                  }, offer));
                }else{
                  schoolChoices.push(Object.assign({
                    isFirst: index === 0,
                    isLast : index === offerIds.length - 1,
                    missing: true,
                    id: id,
                  }));
                }
              }
            });
            this.schoolChoices = schoolChoices;
            this.viewSchoolChoices = this.schoolChoices;
            resolve();
          })
          .catch(reject);
      });
      } else {
      return new Promise((resolve, reject) => {
        const displayItemDetailKeys = [
          'faculty_name',
          'department_name',
          'schedule_name',
          'examination_method_name',
        ];

        const condition = {id: offerIds};
        dn.db.searchOffers(condition)
          .then(hits => {
            const schoolChoices = [];
            offerIds.forEach((id, index) => {
              const offer = hits.hits.find(hit => hit.id === id);
              if (!offer) return;
              const labels = [`【第${index + 1}志望】`, offer.university_name];
              displayItemDetailKeys.forEach(key => {
                const val = offer[key];
                if (val) labels.push(val);
              });

              schoolChoices.push(Object.assign({
                label: labels.join('　'),
              }, offer));
            });
            this.schoolChoices = schoolChoices;
            resolve();
          })
          .catch(reject);
      });
      }
    },

    restoreInfoState() {
      this.info.updateHistories();
      this.mockIsReady = this.info.mockIsReady;
      this.selfcheckIsReady = this.info.selfcheckIsReady;
      this.firstChoiceIsReady = this.info.firstChoiceIsReady;
      this.firstChoiceErrors = this.info.firstChoiceErrors.slice();
    },

    setOfferQuery(index = 0) {
      const val = String(index + 1);
      this.$router.replace({
        query: {
          offer: val,
        },
      });
    },

    setInitialOfferQuery() {
      if (!this.$route.query.offer) {
        this.setOfferQuery();
      }
    },



    /**
     * 「判定の見方」ウィンドウを表示する
     */
    showAboutWindow(e) {
      return window.open(
        this.aboutWindow.url,
        this.aboutWindow.target,
        'width=600, height=560, menubar=no, toolbar=no, scrollbars=yes'
      );
    },

    /**
     * 備考情報の変換
     */
    checkBiko(biko) {
      return biko === "【注意（集計）】大学指定の入試科目以外も含め判定。" ? "【科目違い】判定に必要な科目を受験していなかったので、受験された科目で判定を出しています。" : biko;
    },

    
    /**
     * 志望校DOMのアニメーションを伴う処理を行う時のメソッドラッパー
     * セグメントの監視を一回停止した上で非同期メソッドを行い
     * 完了したら元に戻す
     */
    async animateOfferFunction(promise) {
      if (this.isAnimating) return;
      // TODO:ちらつき解消までのごまかし・・・
      dn.loading.show();
      this.isAnimating = true;
      this.stopWatchSchoolChoices();

      await promise();

      this.isAnimating = false;
      this.startWatchSchoolChoices();
      this.onChangeSchoolChoices();
      
      dn.loading.hide();
    },

    /**
     * 志望校を削除する
     */
    async deleteOffer(e, offer) {
      if (!await dn.$confirm('削除しても宜しいですか？')) return false;
      await new Promise(resolve => { setTimeout(resolve, 150) });
      await this.animateOfferFunction(async () => {
        // チェックボックスを外す
        for (var i=this.pamphletChoices.length-1; i>=0; i--) {
          if (this.pamphletChoices[i] === offer.id) {
            this.pamphletChoices.splice(i, 1);
          }
        }
        dn.segments.schoolChoices.remove(offer.id);

        const $offer = $(e.target).closest('.my-offer');

        // this.PreferredUnivManager.send();

        await new Promise((resolve, reject) => {
          $offer.slideUp(350, resolve);
        });
      });
    },



    /**
     * 志望校の位置を移動する
     */
    async moveOffer(e, offer, vec) {
      await this.animateOfferFunction(async () => {
        dn.segments.schoolChoices.move(offer.id, vec);

        const $offer      = $(e.target).closest('.my-offer'),
              isDown      = vec === 'down',
              $pair       = $offer[isDown ? 'next' : 'prev'](),
              offerHeight = $offer.outerHeight(),
              pairHeight  = $pair.outerHeight(),
              duration    = 700,
              easing      = 'snap';

        $offer.addClass('my-offer--moving');
        $pair.addClass('my-offer--moving');

        const transition = `${duration}ms`;
        const transform = {
          offer: `translateY(${isDown ? pairHeight   : -pairHeight}px)`,
          pair : `translateY(${isDown ? -offerHeight : offerHeight}px)`,
        };
        const resetStyles = {
          'transform': '',
          '-webkit-transform': '',
          transition: '',
        };

        $offer.css({
          'transform': transform.offer,
          '-webkit-transform': transform.offer,
          transition,
        });
        $pair.css({
          'transform': transform.pair,
          '-webkit-transform': transform.pair,
          transition,
        });

        await new Promise(resolve => setTimeout(resolve, duration));
        $offer.css(resetStyles).removeClass('my-offer--moving');
        $pair.css(resetStyles).removeClass('my-offer--moving');

      });

      // this.PreferredUnivManager.send();
    },

    /**
     * 登録志望校更新時のコールバック
     */
    onChangeSchoolChoices() {
      const schoolChoices = dn.segments.schoolChoices.find();

      // すでにフェッチしているデータで足りていないかチェック
      let hasData = false;
      if (this.hits && this.hits.hits) {
        hasData = true;
        for (let id of schoolChoices) {
          if (!this.hits.hits.find(row => row.id === id) && !this.missings.includes(id)) {
            hasData = false;
            break;
          }
        }
      }

      if (!hasData) this.needFetch = true;

      this.$set(this, 'schoolChoices', schoolChoices);
      this.restoreSchoolChoices();

      if (!hasData) this.pushFetchQueue();
    },

    /**
     * セグメントの監視を開始する
     */
    startWatchSchoolChoices() {
      dn.segments.schoolChoices.listen(() => {
        this.onChangeSchoolChoices();
      }, 'pg-bible-myuniv');
    },

    /**
     * セグメントの監視を停止する
     */
    stopWatchSchoolChoices() {
      dn.segments.schoolChoices.stopListen(undefined, 'pg-bible-myuniv');
    },

    /**
     * データをフェッチして変数に保持する
     */
    pushFetchQueue(condition = this.searchValues) {
      return new Promise((resolve, reject) => {
        const myQueue = {
          resolved: false,
          rejected: false,
          running : false,
          done    : false,
          hits    : null,
          error   : null,
        };

        const myIndex = this.fetchQueues.length;

        myQueue.trigger = () => {
          myQueue.running = true;

          const onDone = error => {
            myQueue.running = false;
            myQueue.done    = true;

            const nextQueue = this.fetchQueues[myIndex + 1];

            if (error) {
              reject(error);
            } else {
              resolve();
            }

            return nextQueue ? nextQueue.trigger() : this.onFinishFetchQueues();
          }

          dn.db.searchOffers(condition)
            .then(hits => {
              myQueue.resolved = true;
              myQueue.hits     = hits;
              return onDone();
            })
            .catch(error => {
              myQueue.rejected = true;
              myQueue.done     = true;
              myQueue.error    = error;
              return onDone(error);
            });
        }

        let hasBefore = false;
        if (myIndex > 0) {
          for (let i = 0; i < myIndex; i++) {
            if (this.fetchQueues[i].running || !this.fetchQueues[i].done) {
              hasBefore = true;
              break;
            }
          }
        }

        this.fetchQueues.push(myQueue);

        if (!hasBefore) {
          this.onStartFetchQueues();
          myQueue.trigger();
        }
      });
    },



    /**
     * フェッチキューの実行が開始した時のコールバック
     */
    onStartFetchQueues() {
      this.fecthState = 'fetching';
      dn.loading.show();
    },



    /**
     * フェッチキューの実行が全て完了した時のコールバック
     */
    onFinishFetchQueues() {
      dn.loading.hide();

      let hits;
      const errors = [];

      this.fetchQueues.forEach(queue => {
        if (queue.hits) hits = queue.hits;
        if (queue.error) errors.push(queue.error);
      });

      if (errors.length) {
        this.fecthState = 'error';
        throw new Error(errors);
      }

      if (hits) {
        this.missings = [];
        this.hits = hits;
      }

      this.needFetch = false;
      this.fecthState = 'fetched';
      this.tryFirstHashJumpToOffer();
    },



    /**
     * 初期フェッチ時のハッシュジャンプを試みる
     */
    tryFirstHashJumpToOffer() {
      if (this.hashJumped || !location.hash) {
        this.hashJumped = true;
        return;
      }

      this.hashJumped = true;
      const id = location.hash.replace(/^#my-offer-/, '');
      this.tryScrollToOffer(id);
    },



    /**
     * 指定のIDの志望校へのスクロールを試みる
     */
    tryScrollToOffer(id) {
      this.$nextTick(() => {
        const $offers = this.$refs.offers && this.$refs.offers.length ? this.$refs.offers : null;
        if (!$offers) return;

        const $offer = $offers.find($offer => $offer.id === `my-offer-${id}`);

        if (!$offer) return;
        this.$scrollTo($offer, 250);
      });
    },
  },



  async created() {
    this.setInitialOfferQuery();
    this.info = new JudgementInfo();
    this.fetchQueues = [];
    this.PreferredUnivManager = new PreferredUnivManager();
    if (this.$store.getters["config/isManabi"]) {
      // 志望校ごとに「判定の基となる成績」の高さを揃える
      $(function(){
        var id = setInterval(function(){
          $(".my-judgements__row").each(function() {
            var maxHeadHeight = 0;
            // DK、1次、2次の中で"__head"の高さが一番のものを抽出し、それに合わせる
            $(this).find(".my-judgement__score-base-guide").each(function() {
              maxHeadHeight = Math.max(maxHeadHeight, $(this).prev(".my-judgement__head").outerHeight(true));
            });
            $(this).find(".my-judgement__score-base-guide").each(function(){
              var top = maxHeadHeight - $(this).prev(".my-judgement__head").outerHeight(true);
              if (top > -1) {
                $(this).css("margin-top", (top + 8));
              }
            });
          });
        },500);
      });
    }
  },
}
</script>



// WEBPACK FOOTER //
// App.vue?28cb1e01